exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hidden-input {\n  top: -1000px;\n  position: absolute;\n}\n.warningHint {\n  margin-bottom: 10px;\n}\n", "", {"version":3,"sources":["/home/runner/work/ui/ui/src/screens/OpenQuestion.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB","file":"OpenQuestion.vue","sourcesContent":["\n.hidden-input {\n  top: -1000px;\n  position: absolute;\n}\n.warningHint {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ad98124","scoped":false,"hasInlineConfig":true}!./node_modules/postcss-loader/lib?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./build/strip-block-custom??ref--0-0!./src/screens/OpenQuestion.vue
// module id = 3517
// module chunks = 1853